import React, { useEffect } from "react";
import { Flex } from "rebass";
import { MainLayout } from "../layouts/MainLayout";
import { yodaInfoActions } from "../logic/actions/yodaInfo.actions";
import { useDispatch, useSelector } from "react-redux";
import { stringHtmlConverter } from "../utils/stringHtmlConverter";

const CookiePage = () => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const dispatch = useDispatch();
  const { cookie } = useSelector((state) => state.yodaInfo);

  useEffect(() => {
    dispatch(yodaInfoActions.getCookie());
  }, []);

  useEffect(() => {
    document
      .getElementById("idDiv")
      .appendChild(
        stringHtmlConverter(
          lang === "it" ? cookie?.content?.it || "" : cookie?.content?.en || "",
        ),
      );
  }, [cookie]);

  return (
    <MainLayout client>
      <Flex width={1} flexDirection="column" p={4}>
        <div
          id={"idDiv"}
          className="b-content_asset b-content_asset--privacy-policy content-asset"
        ></div>
      </Flex>
    </MainLayout>
  );
};

export { CookiePage };
